<template>
  <v-flex style="max-width: 210px">
    <v-menu v-model="menuAperto" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
      offset-y max-width="300px">
      <template v-slot:activator="{ on }">
        <v-text-field :disabled="disabled" hide-details clearable @click:clear="clearData" style="cursor: pointer"
          :class="classCustom" color="primary" :value="dataFormattata" :label="label" prepend-icon="event" readonly
          dense v-on="on" />
      </template>
      <v-date-picker color="primary" :value="value" @input="aggiornaData" :first-day-of-week="1" locale="it-it" />
    </v-menu>
  </v-flex>
</template>

<script>
export default {
  name: "CampoData",

  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classCustom: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    menuAperto: false,
  }),

  computed: {
    dataFormattata() {
      if (!this.value) return "";
      try {
        return this.$i2kFunctions.formatISODate(this.value.substring(0, 10));
      } catch {
        return this.value;
      }
    },
  },

  methods: {
    aggiornaData(nuovaData) {
      this.$emit("input", nuovaData);
      this.menuAperto = false;
    },

    clearData() {
      this.$emit("input", null);
    },
  },
};
</script>
